import { Alert, AppLayout, Box, Flashbar, Spinner, SideNavigation, TopNavigation } from '@cloudscape-design/components';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from './auth/useAuth';
import { useNotifications } from './notifications/useNotifications';

export default function App() {
  const { user, loading, authError, signOut } = useAuth();
  const { items: flashItems } = useNotifications();
  const navigate = useNavigate();

  // authError: Cognito config was bad enough that sign-in could not even be
  // attempted (this happened in production — the build-time VITE_USER_POOL_ID
  // etc. were unset, so oidc-client-ts threw resolving the discovery
  // document). Show it plainly rather than the app shell over a null user.
  if (authError) {
    return (
      <Box padding="xxl">
        <Alert type="error" header="Sign-in is unavailable">
          {authError} Reloading may not help — this usually means the deployed
          build is missing its Cognito configuration. Contact the site owner.
        </Alert>
      </Box>
    );
  }

  // While the redirect to Cognito is in flight (or the callback is still
  // being processed), render nothing but a spinner rather than the full app
  // shell — briefly showing authenticated-looking chrome to a signed-out
  // visitor is the wrong default, however short the window.
  if (loading) {
    return (
      <Box padding="xxl" textAlign="center">
        <Spinner size="large" />
      </Box>
    );
  }

  return (
    <>
      <TopNavigation
        identity={{ href: '/', title: 'energydash' }}
        utilities={[
          {
            type: 'menu-dropdown',
            text: user?.email ?? 'Account',
            iconName: 'user-profile',
            items: [{ id: 'signout', text: 'Sign out' }],
            onItemClick: (e) => {
              if (e.detail.id === 'signout') signOut();
            },
          },
        ]}
      />
      <AppLayout
        toolsHide
        navigation={
          <SideNavigation
            header={{ text: 'energydash', href: '/' }}
            items={[
              { type: 'link', text: 'Overview', href: '/' },
              { type: 'link', text: 'Circuits', href: '/circuits' },
              { type: 'link', text: 'Cost & Utility', href: '/cost' },
              { type: 'link', text: 'Data Quality', href: '/data-quality' },
            ]}
            onFollow={(e) => {
              if (!e.detail.external) {
                e.preventDefault();
                navigate(e.detail.href);
              }
            }}
          />
        }
        notifications={<Flashbar items={flashItems} stackItems />}
        content={<Outlet />}
      />
    </>
  );
}
